import script from "./TagList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagList.vue?vue&type=script&setup=true&lang=ts"

import "./TagList.vue?vue&type=style&index=0&id=ba198080&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba198080"]])

export default __exports__